import { useEffect } from "react";
import aboutUs from "../../../assets/images/aboutUs.jpg";

const AboutUs = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center pb-12 bg-gray-100 min-h-screen">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-left mb-12 pt-20 space-y-6">
          <h1 className="text-6xl font-bold text-[#730000] mb-4 pt-4">About Us</h1>
          <div className="space-y-3 font-seasons text-xl">
            <p className="">
              Finding the perfect life partner is one of the most significant
              decisions in life!{" "}
            </p>
            <p className="pb-5">
              As Pakistan’s premier matrimonial platform, we specialize in
              matchmaking for educated, like-minded individuals who are looking
              for genuine and lasting connections.{" "}
            </p>
            <p className="">
              Our mission is to bring together compatible matches who share
              values, aspirations, and a vision for the future.{" "}
            </p>
          </div>
          <img src={aboutUs} className="w-full" />
        </div>
        <h2 className="text-5xl font-semibold text-[#730000] mb-4 text-left pt-12 pb-6">
          Why Choose Select Proposal?
        </h2>
        {/* About Us Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white p-8 rounded-lg shadow-md transition-all duration-300 hover:opacity-90 hover:scale-105 hover:shadow-lg">
            <h2 className=" text-4xl font-bold text-[#730000] mb-4">
              Tailored Matches for Educated Professionals
            </h2>
            <p className="text-gray-600 font-seasons">
              We understand the importance of compatibility beyond just basic
              details. Our platform is designed for individuals who prioritize
              education, career growth, and shared intellectual values in a
              marriage. We ensure that you connect with highly qualified
              professionals, making your search efficient and meaningful.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-md transition-all duration-300 hover:opacity-90 hover:scale-105 hover:shadow-lg">
            <h2 className="text-4xl font-bold text-[#730000] mb-4">
              Authentic and Verified Profiles
            </h2>
            <p className="text-gray-600">
              Trust and authenticity are at the core of our service. Every
              profile on Select Proposal undergoes a rigorous verification
              process to ensure genuine and reliable matches. Say goodbye to
              fake accounts and irrelevant connections—we provide a safe and
              credible environment for your search.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-md transition-all duration-300 hover:opacity-90 hover:scale-105 hover:shadow-lg">
            <h2 className="text-4xl font-bold text-[#730000] mb-4">
              Personalized Matchmaking Experience
            </h2>
            <p className="text-gray-600">
              We don’t believe in generic matchmaking. Our advanced
              compatibility algorithms and expert matchmakers work tirelessly to
              recommend profiles that align with your personality, values, and
              lifestyle. Whether you prefer a traditional approach or a modern
              outlook, we cater to your preferences.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-md transition-all duration-300 hover:opacity-90 hover:scale-105 hover:shadow-lg">
            <h2 className="text-4xl font-bold text-[#730000] mb-4">
              Culturally Rooted, Future-Focused
            </h2>
            <p className="text-gray-600">
              While we embrace modern matchmaking techniques, we deeply respect
              Pakistani cultural values. We strike the perfect balance between
              tradition and progress, ensuring that your journey to finding a
              life partner is both respectful and forward-thinking.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-md transition-all duration-300 hover:opacity-90 hover:scale-105 hover:shadow-lg">
            <h2 className="text-4xl font-bold text-[#730000] mb-4">
              Confidential & Secure
            </h2>
            <p className="text-gray-600">
              Privacy is a top priority at Select Proposal. Your information
              remains secure, and you have complete control over who can view
              your profile. Our discreet matchmaking service ensures that your
              search remains confidential until you decide to take the next
              step.{" "}
            </p>
          </div>
        </div>
        {/* Call to Action */}
        <div className="text-left mt-12 py-5">
          <h2 className="text-4xl font-bold text-[#730000] mb-4">
            Ready to Start Your Journey?
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl  mb-6">
            Don’t leave your future to chance—take control of your destiny with
            Select Proposal. Whether you are searching for a soulmate who shares
            your ambitions or a companion who complements your values, we are
            here to guide you every step of the way.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
